module.exports = __webpack_public_path__ + "static/img/nav3.4b1345e5.png";